module.exports = __webpack_public_path__ + "img/hr-assembling-machine-3-pipe-W.1cb3618f.png";